import { DataItemType, FormControlType } from "../../../../form/schema";
import schema from "./schema";
import conduct from "./conduct";
import pc from "./components/pc-sheet.vue";
import mobile from './components/mobile-sheet.vue';
const info = {
    title: "子表",
    title_i18n: "{\"zh\": \"子表\", \"en\": \"Sheet\"}",
    type: "sheet",
    icon: "h-icon-all-table-o",
    dataItemType: DataItemType.Sheet,
    formControllerType: FormControlType.Sheet,
    group: "布局控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        pc,
        mobile
    },
};
